import styled from 'styled-components'
import React, { useState } from 'react'
import { ListViewIcon, CardViewIcon, IconButton } from '@pancakeswap/uikit'


const Container = styled.div`
  margin-left: -8px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 0;
  }
`
interface Poolcardview {
  setIsToggleview?:any;
}

const ToggleView: React.FunctionComponent<Poolcardview> = ({ setIsToggleview }) => {

  const [tableView, setTableView] = useState(true);
  // const toggleView = () =>{
  //   setTableView(!tableView)
  // }
  return (
    <Container>
      <IconButton variant="text" scale="sm" id={`CardView`} >
        <CardViewIcon color={tableView ? 'textDisabled' : '#00FED9'} onClick={()=>{setTableView(false); setIsToggleview(false) }}/>
      </IconButton>
      <IconButton variant="text" scale="sm" id={`TableView`}>
        <ListViewIcon color={tableView ? '#00FED9' : 'textDisabled'} onClick={()=>{setTableView(true); setIsToggleview(true) } }/>
      </IconButton>
    </Container>
  )
}

export default ToggleView
